module.exports = __webpack_public_path__ + "img/m7.e842459.jpg";